import { Injectable } from '@angular/core';

import { TranslationISO } from '../../models/translation.model';

@Injectable({
    providedIn: 'root',
})
export class TranslationService {
    getTranslationKey(value: string): string | null {
        for (const lang in TranslationISO) {
            if (TranslationISO.hasOwnProperty(lang)) {
                if (TranslationISO[lang] === value) {
                    return lang;
                }
            }
        }
        return null;
    }
}
